import { useEffect, useState } from "react";
import { MoonStar, X } from "lucide-react";
import { api, money } from "../api";
import { fmtDT } from "../lib/units";

export function useOvernight(branch) {
  const [d, setD] = useState(null);
  useEffect(() => {
    if (!branch) return undefined;
    let live = true;
    const load = () => api.get("/alerts/overnight").then((r) => live && setD(r.data)).catch(() => {});
    load();
    const t = setInterval(load, 5 * 60 * 1000);
    return () => { live = false; clearInterval(t); };
  }, [branch]);
  return d;
}

export function OvernightBanner({ data, onOpen }) {
  const key = `fd_overnight_dismiss_${data?.business_date}`;
  const [, setTick] = useState(0);
  const hidden = !!data?.business_date && !!localStorage.getItem(key);
  if (!data || hidden || (!data.tables && !data.stale_kots)) return null;
  return (
    <div className="digest-banner overnight" data-testid="overnight-banner">
      <MoonStar size={16} />
      <div>
        <b>{data.tables} table(s) left open overnight{data.stale_kots ? ` · ${data.stale_kots} old KOT(s) not served` : ""}</b>
        {data.branches.map((b) => (
          <small key={b.branch} data-testid={`overnight-branch-${b.branch}`}>
            {b.branch_name}: {b.tables.slice(0, 8).map((t) => `${t.table_label}${t.waiter_name ? ` (${t.waiter_name})` : ""} since ${fmtDT(t.opened_at)}`).join(" · ") || "no open tables"}
            {b.tables.length > 8 ? ` · +${b.tables.length - 8} more` : ""} · {money(b.amount)} unbilled
          </small>
        ))}
        {data.notified?.whatsapp?.length > 0 && <small data-testid="overnight-notified">Owner alerted on WhatsApp (MOCKED) at {fmtDT(data.notified.created_at)}</small>}
      </div>
      <button className="secondary-button" onClick={onOpen} data-testid="overnight-open-tables">Bill or close</button>
      <button className="icon-button" title="Hide until tomorrow" onClick={() => { localStorage.setItem(key, "1"); setTick((x) => x + 1); }} data-testid="overnight-dismiss"><X size={14} /></button>
    </div>
  );
}
